import React from "react";
import PropTypes from "prop-types";
import RotSection from "./RotSection";
import ImageOne from "../images/landing/rotSection/section_1_image.webp";
import ImageTwo from "../images/landing/rotSection/section_2_image.webp";
import Image from "../images/landing/rotSection/section_image.webp";
import ImageThree from "../images/landing/rotSection/section_3_image.webp";
import ImageFour from "../images/landing/rotSection/section_4_image.webp";

const Reward = ({ rewardName, value, text, link, borderBottom }) => {
  return (
    <p
      className={borderBottom ? "border-b border-gray-500  pb-3 pt-3" : "pt-3"}
    >
      <span className="font-bold">{rewardName} </span>
      {value && <span className="font-bold italic">{value} </span>} {text}{" "}
    </p>
  );
};

const RotSections = ({}) => {
  return (
    <section className="bg-white pt-3">
      <div className="max-w-page md:px-5">
        {/* Section 1 */}
        <RotSection
          subtitle="Anyone & Everyone"
          title="No credit score? Np"
          img={ImageOne}
          flip
        >
          <p>
            You are worth more than just a number (a.k.a. an arbitrary credit
            score). We evaluate individual circumstances and take into account
            alternative metrics to determine your credit worthiness.
          </p>
        </RotSection>
        <RotSection subtitle='Never miss a payment' title='Build your credit the smart way' img={Image}>
          <p>
            Not only does Tomo report to all 3 major credit bureaus but we are the first card to offer expedited weekly payments.
            Always pay on time
            and watch your credit score grow!
          </p>
        </RotSection>

        {/* Section 2 */}
        <RotSection
          subtitle="WORLD ELITE MASTERCARD"
          title="Rewards that matter"
          img={ImageTwo}
          flip
        >
          <div className="-mt-3">
            <Reward
              key={1}
              rewardName="DoorDash"
              value="$90 Value"
              text="Free 3 months
                      of DashPass and $5 off each month, plus more!"
              link="https://www.doordash.com/dashpass-v2/mastercard"
              borderBottom
            />
            <Reward
              key={2}
              rewardName="ShopRunner"
              value="$79 Value"
              text="Free membership, free 2-Day shipping, and free returns."
              link="https://www.shoprunner.com/enroll/mastercard"
              borderBottom
            />
            <Reward
              key={3}
              rewardName="Lyft"
              value="$60 Value"
              text="Take 3 rides with Lyft and earn $5 in credit."
              link="https://www.lyft.com/mastercard"
            />
          </div>
        </RotSection>

        {/* Section 3 */}
        <RotSection
          subtitle="WORLD ELITE MASTERCARD"
          title="Always feel like a VIP"
          img={ImageThree}
        >
          <div className="-mt-3">
            <Reward
              key={4}
              rewardName="Fandango"
              text="Spend $20 on movie tickets or streaming and get $5 off your next purchase."
              link="https://worldelitemc.fandango.com/"
              borderBottom
            />
            <Reward
              key={5}
              rewardName="Priceless Cities"
              text="Access to travel rewards in over 40 cities around the globe."
              link="https://www.priceless.com/"
              borderBottom
            />
            <Reward
              key={6}
              rewardName="Priceless Golf"
              text="Exclusive PGA Tour experiences and access to 1000+ private clubs."
              link="https://www.priceless.com/golf/"
              borderBottom
            />
            <Reward
              key={7}
              rewardName="World Elite Concierge"
              text="A 24/7 concierge service that helps you locate hard to find items, e.g. a sold out show."
              link="https://worldeliteconcierge.mastercard.com/sign_in.aspx"
            />
          </div>
        </RotSection>

        {/* Section 4 */}
        <RotSection
          subtitle="WORLD ELITE MASTERCARD"
          title="Peace of Mind"
          img={ImageFour}
          flip
        >
          <div className="-mt-3">
            <Reward
              key={8}
              rewardName="Cellphone Protection"
              text="For stolen or damaged phones."
              link="https://us.mycardbenefits.com/"
              borderBottom
            />
            <Reward
              key={9}
              rewardName="ID Protection"
              text="Specialists available 24/7/365, plus suspicious activity alerts."
              link="https://mastercardus.idprotectiononline.com/enrollment/embedded.html"
              borderBottom
            />
            <Reward
              key={10}
              rewardName="Zero Liability"
              text="You're not responsible if someone makes an unauthorized purchase."
              link="https://www.mastercard.us/en-us/personal/get-support/zero-liability-terms-conditions.html"
              borderBottom
            />
            <Reward
              key={11}
              rewardName="Global Assistance"
              text="Anytime, anywhere, in any language."
              link="https://www.mastercard.us/content/dam/mccom/global/documents/global-services-phone-numbers.pdf"
            />
          </div>
        </RotSection>
      </div>
      <div className="border-b border-gray-200 w-10/12 mx-auto md:max-w-page mt-12 mb-32 md:mt-0 md:mb-10"></div>
    </section>
  );
};
RotSections.propTypes = {
  siteTitle: PropTypes.string,
};

RotSections.defaultProps = {
  siteTitle: ``,
};

export default RotSections;
